import { ReactElement } from 'react';

import { PrismicRichText } from '@prismicio/react';
import { PrismicNextImage } from '@prismic/components/PrismicNextImage';

import { generateKey } from '@utils/core';

import { IProps } from './types';
import * as S from './styles';

export function SliceContentPhotoText({
  slice: { label, primary },
}: IProps): ReactElement {
  const reverse = label ? label.includes('_-') : true;
  const width = label ? label.slice(0, 2) : 50;

  return primary ? (
    <S.Wrapper className="slice-item blog-text-photo">
      <S.Container reverse={reverse}>
        <S.Photo
          key={generateKey(
            primary?.content_text.slice(0, 9),
            'text-photo__photo'
          )}
          width={width}
        >
          {primary?.content_photo && (
            <>
              {primary.photo_link ? (
                <a href={primary.photo_link} target="_blank" rel="noreferrer">
                  <PrismicNextImage
                    field={primary.content_photo}
                    style={{ maxWidth: '100%', height: '100%', margin: 'auto' }}
                  />
                </a>
              ) : (
                <PrismicNextImage
                  field={primary.content_photo}
                  style={{ maxWidth: '100%', height: '100%', margin: 'auto' }}
                />
              )}
            </>
          )}
        </S.Photo>
        <S.Paragraph
          key={generateKey(
            primary?.content_text.slice(0, 9),
            'text-photo__paragraph'
          )}
          width={width}
        >
          {primary?.content_text && (
            <S.Content>
              <PrismicRichText field={primary?.content_text} />
            </S.Content>
          )}
        </S.Paragraph>
      </S.Container>
    </S.Wrapper>
  ) : null;
}

SliceContentPhotoText.componentName = 'blog-content-text-photo';
